/**
 * Одна кнопка «Заполнить план» вместо трёх рядом (решение founder 04.09 п.1).
 *
 * Три равноправные кнопки читались как три разные фичи, хотя намерение у
 * агронома одно — «разложи культуры по полям», и отличается только способ.
 * Поэтому кнопка одна, а способ выбирается внутри; счётчик на кнопке —
 * сколько полей сейчас без культуры, то самое множество, которое способ и
 * разберёт.
 *
 * Недоступный пункт гасится С ПРИЧИНОЙ и не прячется: исчезнувший пункт
 * возвращается вопросом «а где повтор прошлого года», погашенный с подписью
 * отвечает на него сам.
 */
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { fillMethodOptions, type FillMethod } from '@/lib/planning/autoBuild';

export function FillPlanMenu({
  method,
  variantStatus,
  freeFields,
  onPick,
}: {
  method: FillMethod;
  /** Статус варианта: на утверждённом автосбор по целям недоступен (FR-2). */
  variantStatus: string;
  freeFields: number;
  onPick: (method: FillMethod) => void;
}) {
  const options = fillMethodOptions(variantStatus);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" size="sm">
          Заполнить план
          {freeFields > 0 && (
            <Badge variant="secondary" className="ml-2">
              {freeFields}
            </Badge>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-80">
        <DropdownMenuLabel>Способ заполнения</DropdownMenuLabel>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.method}
            disabled={!!option.disabledReason}
            // Пункт остаётся в дереве и с погашенным состоянием: скринридер
            // обязан прочитать причину так же, как её читает глаз.
            aria-disabled={!!option.disabledReason}
            onSelect={() => {
              if (option.disabledReason) return;
              onPick(option.method);
            }}
            className="flex-col items-start gap-1"
          >
            <span className="flex w-full items-center justify-between gap-2 text-sm font-medium">
              {option.title}
              {method === option.method && !option.disabledReason && (
                <span className="text-xs font-normal text-muted-foreground">выбрано</span>
              )}
            </span>
            <span className="text-xs font-normal text-muted-foreground">
              {option.disabledReason ?? option.hint}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
